import { render } from "./NewsFeedTopic.vue?vue&type=template&id=b96ff3ea&scoped=true"
import script from "./NewsFeedTopic.vue?vue&type=script&lang=js"
export * from "./NewsFeedTopic.vue?vue&type=script&lang=js"

import "./NewsFeedTopic.vue?vue&type=style&index=0&id=b96ff3ea&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b96ff3ea"]])

export default __exports__